export default __webpack_public_path__ + "maps-guides-styles-layers-raster-layer-1200-036bc2c66d302f1a240907730f9abe9f.webp";